"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.urlToFileName = exports.getExtension = exports.convertToMb = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var urlToFileName = url => {
  var _context;
  var [, file, type] = url.match(/\/(?:[0-9]+)-(?:[0-9]+)\.(.*?)(?:\.([a-zA-Z0-9]+))?$/) ||
  // Remove encoded spaces
  url.replace(/%20/g, ' ')
  // Remove uuid
  .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i, '').match(/.*\/(?:(?:[0-9]+)-(?:[0-9]+)\.)?(.*?)(?:\.([a-zA-Z0-9]+))?$/) || [];
  var name = file ? (0, _trim.default)(_context = file
  // Replace . _ - (number) with space
  .replace(/\.|_|-|(\([0-9]\))/g, ' ')
  // Add space between lowercase -> uppercase
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  // Add space between non-alphanum -> alphanum
  .replace(/([^a-z0-9 '])([a-z0-9])/gi, '$1 $2')
  // Add space between alphanum -> non-comma-alphanum
  .replace(/([a-z0-9])([^a-z0-9 ',])/gi, '$1 $2')
  // Add space between letter -> number
  .replace(/([a-z])([0-9])/gi, '$1 $2')
  // Add space between number -> letter
  .replace(/([0-9])([a-z])/gi, '$1 $2')
  // Remove duplicate spaces
  .replace(/\s{2,}/g, ' ')).call(_context) : '';
  return {
    type: type || '',
    name: name || ''
  };
};

// TODO: handle very small files more gracefully
exports.urlToFileName = urlToFileName;
var convertToMb = size => Number((size / 1024 / 1024).toFixed(1)) > 0 ? ", ".concat((size / 1024 / 1024).toFixed(1), " MB") : ', 0.01 MB'; // lie, but it gives the idea that it's tiny
exports.convertToMb = convertToMb;
var getExtension = type => type && type.substring((0, _indexOf.default)(type).call(type, '/') + 1, type.length).toUpperCase();
exports.getExtension = getExtension;